export default class Platform {}

Platform.Web = 'WEB';
